import {useState} from "react";

import {sessionCache} from "@pg-rp/session-cache";

import {NAV_USER_ICON_POPOVER_SHOWN} from "../constants/storage_keys";

export const useUserPopover = () => {
    const [isPopoverActive, setIsPopoverActive] = useState(false);

    const onHoverUserIcon = () => {
        if (sessionCache.get<boolean>(NAV_USER_ICON_POPOVER_SHOWN)) {
            return;
        }
        setIsPopoverActive(true);
        sessionCache.set(NAV_USER_ICON_POPOVER_SHOWN, true);
    };

    const onPopoverClose = () => {
        setIsPopoverActive(false);
    };

    return {
        isPopoverActive,
        onPopoverClose,
        onHoverUserIcon
    };
};
